const state = {
    isPC: true,
    viewportWidth: 0
}

const mutations = {
    UPDATE_DEVICE(state) {
        state.viewportWidth = document.documentElement.clientWidth
        state.isPC = state.viewportWidth >= 1024
    }
}

const actions = {
    initDeviceListener({ commit }) {
        if (typeof window === 'undefined') return

        const handler = () => {
            commit('UPDATE_DEVICE')
        }

        // 初始执行
        handler()

        // 添加监听
        window.addEventListener('resize', handler)

        // 注册卸载钩子
        window.addEventListener('beforeunload', () => {
            window.removeEventListener('resize', handler)
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}